import { Record } from 'immutable';
import { THREAD_STATUS_REMOVAL } from '../constants/overlayTypes';
const ThreadStatusRemovalOverlay = Record({
  audit: null,
  type: THREAD_STATUS_REMOVAL,
  status: null
}, 'ThreadStatusRemovalOverlay');
export default ThreadStatusRemovalOverlay;